var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"block pl-5 pr-2 py-1 font-open-sans text-xl tracking-wide transition duration-150 ease-in-out font-semibold uppercase",attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }